var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fbe8ce;}.cls-3,.cls-4,.cls-8{fill-rule:evenodd;}.cls-4,.cls-5{fill:#685d4a;}.cls-6{fill:#333;opacity:0.8;}.cls-7{fill:#99a5ff;}.cls-8{fill:#eaccac;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 143,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.13,77a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.45,77a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.7,24.57a40.16,40.16,0,0,1,40,40.34v40.34c0,22.19-25.06,37.83-40,40.35-5.12-.52-40-18.16-40-40.35V64.91a40.17,40.17,0,0,1,40-40.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.9,80.81A1.41,1.41,0,1,1,48.74,78L60,77.34a1.41,1.41,0,0,1,.16,2.82l-11.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.08,80.3a1.41,1.41,0,0,1,.1-2.82l11.29.37a1.42,1.42,0,0,1,1.37,1.46,1.41,1.41,0,0,1-1.46,1.36l-11.3-.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 55.13,
    cy: 85.99,
    r: 3.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 88.93,
    cy: 85.99,
    r: 3.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.1,77.64c-5.82,1.64-6,15.66-5.63,8.18S93.3,75.54,100.26,69s.76-22.34,5.26-24.08C111,42.81,117.74,71.33,115.1,77.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30,75.77c5.83,1.64,6,15.66,5.64,8.18s16.17-10.28,9.21-16.83S44.05,44.78,39.55,43C34.1,40.94,27.33,69.46,30,75.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.25,78.21c-.46,1.67-2.13,7.9-.46,11.25S40.9,99,48,99.64s11.71-1.06,14-4.1,4.56-6.24,3.19-11.4S62.64,79,59.14,77.75,37.25,78.21,37.25,78.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.82,78.21c-.46,1.67-2.13,7.9-.46,11.25S83.47,99,90.61,99.64s11.71-1.06,14-4.1,4.56-6.24,3.2-11.4-2.59-5.17-6.09-6.39S79.82,78.21,79.82,78.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.69,79.84s-6.51,2.82-6.51,6.3a15.75,15.75,0,1,1-31.49,0v.68h-6.3A2.24,2.24,0,0,1,27.13,85a2.06,2.06,0,0,1,2.05-2.3l6,.1V83a7.43,7.43,0,0,1,7.62-6.87H56.46a10.71,10.71,0,0,1,8.61,4,10.2,10.2,0,0,1,8.62-4.45v4.21ZM57.43,78.13H44.51a6.88,6.88,0,0,0-6.82,7h0c0,6.88,4.79,13.06,11.61,14A13.67,13.67,0,0,0,64.93,85.62a7.53,7.53,0,0,0-7.48-7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.69,79.9V75.7a10,10,0,0,1,8.55,4.42,10.56,10.56,0,0,1,8.53-4h13.65a7,7,0,0,1,7.27,6.9v-.11l6.22-.16A2.14,2.14,0,0,1,118.08,85a2.17,2.17,0,0,1-2.2,1.87l-6.19,0V86.2a15.79,15.79,0,0,1-31.58,0,6.09,6.09,0,0,0-6.42-6.3ZM87.8,78.13a7.55,7.55,0,0,0-7.46,7.53A13.71,13.71,0,0,0,96,99.23c6.82-1,11.68-7.12,11.68-14v-.06a7,7,0,0,0-7-7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "80.58 80.44 64.25 80.18 54.02 75.57 89.73 75.75 80.58 80.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.49,101,76,91.66a2.33,2.33,0,1,0-4.65.23h0l.36,7L70.21,99c-3.85.2-6,3.5-5.82,7.36s1.83,6.84,5.7,6.64l4.67-.25a2.31,2.31,0,0,0,2.2-2.44Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual5);
export default __webpack_public_path__ + "static/media/character-head-individual-5.41b6cf8e54d5be77c58fee99485381e4.svg";
export { ForwardRef as ReactComponent };